import { render, staticRenderFns } from "./liangyou.vue?vue&type=template&id=363d0472&"
import script from "./liangyou.vue?vue&type=script&lang=js&"
export * from "./liangyou.vue?vue&type=script&lang=js&"
import style0 from "./liangyou.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports